import type { JSX } from 'react';
import { Seo } from '@/components/seo';
import { TenantProfilesPanel } from '@/components/dashboard/tenantProfiles/TenantProfilesPanel';

export function DashboardTenantProfiles(): JSX.Element {
  return (
    <section className="flex flex-col gap-xl py-8">
      <Seo
        title="Tenant Profiles"
        description="Preview the 501 Alliance tenant roster showcased on The Strashin Collective."
        canonicalPath="/dashboard/tenant-profiles"
        noIndex
      />

      <header className="flex flex-col gap-xs">
        <h1 className="text-2xl font-semibold text-brand-primary md:text-3xl">Tenant Profiles</h1>
        <p className="text-sm text-text-primary/70">
          A read-only view of the 501 Alliance tenant roster that powers The Strashin Collective
          microsite. Select a tenant to preview its full profile.
        </p>
      </header>

      <TenantProfilesPanel />
    </section>
  );
}
